var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "btn-group-vertical d-flex", attrs: { role: "group" } },
      [
        _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
          _c(
            "button",
            {
              staticClass: "btn text-left",
              class:
                _vm.FirstItemSelected === true
                  ? "btn-primary"
                  : "btn-outline-secondary",
              staticStyle: { padding: "0.75rem 1.25rem" },
              attrs: { type: "button", "data-toggle": "dropdown" },
            },
            [
              _vm.FirstItemSelected === true
                ? _c("i", {
                    staticClass: "fa fa-circle-thin",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.FirstItemSelected === true
                ? _c(
                    "span",
                    {
                      staticClass: "badge badge-pill badge-light text-primary",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-check",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.ScaleLabel) + "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(
                "\n\n                " +
                  _vm._s(_vm.firstAlternativeName) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            [
              _c("h4", { staticClass: "dropdown-header" }, [
                _vm._v("How strong is your preference?"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(2)
                    },
                  },
                },
                [_vm._v("Weak")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(3)
                    },
                  },
                },
                [_vm._v("Moderate")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(4)
                    },
                  },
                },
                [_vm._v("Moderate +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(5)
                    },
                  },
                },
                [_vm._v("Strong")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(6)
                    },
                  },
                },
                [_vm._v("Strong +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(7)
                    },
                  },
                },
                [_vm._v("Very strong")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(8)
                    },
                  },
                },
                [_vm._v("Very strong +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(9)
                    },
                  },
                },
                [_vm._v("Extreme")]
              ),
              _vm._v(" "),
              _vm.FirstItemSelected === true
                ? [
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateValue(null)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-times text-danger",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                        Clear\n                    "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn text-left",
            class:
              _vm.EqualitySelected === true
                ? "btn-primary"
                : "btn-outline-secondary",
            staticStyle: { padding: "0.75rem 1.25rem" },
            attrs: { type: "button" },
            on: { click: _vm.SetEqualCommand },
          },
          [
            _c("i", {
              staticClass: "fa",
              class:
                _vm.EqualitySelected === true
                  ? "fa-check-circle"
                  : "fa-circle-thin",
            }),
            _vm._v("\n            Equally preferred\n        "),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
          _c(
            "button",
            {
              staticClass: "btn text-left",
              class:
                _vm.SecondItemSelected === true
                  ? "btn-primary"
                  : "btn-outline-secondary",
              staticStyle: { padding: "0.75rem 1.25rem" },
              attrs: { type: "button", "data-toggle": "dropdown" },
            },
            [
              _vm.SecondItemSelected === true
                ? _c("i", {
                    staticClass: "fa fa-circle-thin",
                    attrs: { "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.SecondItemSelected === true
                ? _c(
                    "span",
                    {
                      staticClass: "badge badge-pill badge-light text-primary",
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-check",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.ScaleLabel) + "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(
                "\n\n                " +
                  _vm._s(_vm.secondAlternativeName) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            [
              _c("h4", { staticClass: "dropdown-header" }, [
                _vm._v("How strong is your preference?"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 2.0)
                    },
                  },
                },
                [_vm._v("Weak")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 3.0)
                    },
                  },
                },
                [_vm._v("Moderate")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 4.0)
                    },
                  },
                },
                [_vm._v("Moderate +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 5.0)
                    },
                  },
                },
                [_vm._v("Strong")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 6.0)
                    },
                  },
                },
                [_vm._v("Strong +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 7.0)
                    },
                  },
                },
                [_vm._v("Very strong")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 8.0)
                    },
                  },
                },
                [_vm._v("Very strong +")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: {
                    click: function ($event) {
                      return _vm.updateValue(1.0 / 9.0)
                    },
                  },
                },
                [_vm._v("Extreme")]
              ),
              _vm._v(" "),
              _vm.SecondItemSelected === true
                ? [
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateValue(null)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-times text-danger",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                        Clear\n                    "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("textarea", {
      staticClass: "form-control my-3",
      attrs: { rows: "3", placeholder: "Comment..." },
      domProps: { value: _vm.comment },
      on: {
        input: function ($event) {
          return _vm.updateComment($event.target.value)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }